<template>
    <div class="add-interior-thumb clearfix">
        <span class="thumbnail" v-for="([img_seq, img_url], idx) in value">
          <a  v-if="editable" class="icon-remove" @click.prevent="delDrImg(idx)"><icon name="times-rectangle"></icon></a>
          <img :src="img_url" alt="">
        </span>
        <span class="thumbnail-btn add-interior-thumb-upload" v-if="editable && addable">
            <a @click.prevent="upload_button_click"><span>+</span></a>
            <input type="file" name="babo2" ref="fileInput" style="display: none" @change="img_add" accept="image/*" capture="filesystem"/>
        </span>
    </div>
</template>

<script>

  export default {
    name: 'images-gallery-dr',
    props: {
      'value': {},
      'editable': { default: true}
    },
    data () {
      return {
        addable: true  
      }
    },
    computed: {
    },
    methods: {
        delDrImg (index) {
          let imgs = [...this.value]
          let [[img_id, img_url]] = imgs.splice(index, 1) // splice 는 array로 반환한다.
          // console.log(img_id, img_url)

          this.$emit('onDelete', img_id)
          this.addable = true;

          // if (img_id !== 'new') imgs.push(img_id)
          this.$emit('input', imgs)
          
        },
        addDrImg (img_seq, img_url, file_obj) {
          
          let imgs = [...this.value]
          imgs.push([img_seq, img_url, file_obj])
          if(imgs.length==2) this.addable = false;
          this.$emit('input', imgs)
        },
        img_add ( event ) {
          // event.target.files<FileList>[<File>] 형태로 구성되어있음
          var file_obj = event.target.files[0]

          var reader = new FileReader();
          reader.onload = (e) => {
            this.addDrImg('new', e.target.result, file_obj)
          }
          reader.readAsDataURL(file_obj)
          // commit('addHospObjToTemp', file_obj)
        },
        upload_button_click () {
          let imgs = [...this.value]
          if (imgs.length >= 2) {
            alert('의사 이미지는 2장까지 업로드가 가능합니다.')
          } else {
            this.$refs.fileInput.click()
          }
        }
    },
    mounted () {

    },
    updated() {
      this.addable = (this.value.length<2)
    }
  }
</script>

<style scoped>

    .fa-icon {
        color: #736ee6;
        background-color: white;
    }
        /* 과거 소스에서 가져온 이미지 등록관련 */

    .thumbnail {
        /*padding:4px;*/
        border: 1px solid #ddd;
        display: inline-block;
        float:left;
        overflow: hidden;
        position:relative;
        line-height: 0;
      }

    .thumbnail img {
        width: 100%
    }
    .thumbnail .icon-remove {
        position: absolute;
        left: 0;
        top: 0;
    }

    /*.thumbnail img {*/
        /*width: 100px;*/
        /*height: 100px;*/
      /*}*/

    /*.thumbnail-btn {*/
        /*display: inline-block;*/
        /*float:left;*/
        /*overflow: hidden;*/
        /*position:relative;*/
        /*padding: 6px 12px;*/
        /*border:1px solid #ddd;*/
        /*margin: 5px 0 0 10px;*/
        /*background-color: #bbb;*/
        /*border-radius: 10px;*/
        /*line-height: 25px;*/
        /*color: #fff;*/
      /*}*/

    .thumbnail-btn a {
        font-weight:bold;
        display: block;
        /*width: 100px;*/
        width: 100%;
        height: 100%;
        font-size: 12px
      }

    .add-interior-thumb {font-size: 0;}
    .add-interior-thumb span {
        float: left;
        width: 353px;
        height: 90px;
        margin: 0 10px 10px 0;
    }

    .add-interior-thumb-upload {
        display: inline-block;
        width: 120px;
        height: 90px;
        border: none;
        position: relative;
        border: 1px solid #e2e2e2;
        background-color: transparent;
    }

    .add-interior-thumb-upload span {
        display: block;
        width: 35px;
        height: 35px;
        color: #d2d2d2;
        position: absolute;
        text-align: center;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        border: 1px solid #d2d2d2;
        transform: translate(-50%, -50%);
        font: 400 24px/35px 'Noto Sans KR', sans-serif;
    }

</style>